import AppLayout from '@/layout/AppLayout.vue';
import { useAuthStore } from '@/store/auth-store';
import { useRouterStore } from '@/store/router-store';
import { useSignupAccessStore } from '@/store/signup-access-store';
import { markRaw } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

const modules = import.meta.glob('@/views/pages/**/*.vue');

export async function loadComponent(componentPath) {
    const path = `/src/views/pages/${componentPath}.vue`;
    if (modules[path]) {
        const module = await modules[path]();
        return { ...module.default, name: module.default.name || componentPath };
    } else {
        console.error(`Component not found: ${path}`);
        const errorModule = await import('@/views/pages/auth/Error.vue');
        return { ...errorModule.default, name: 'Error' };
    }
}

export async function addDynamicRoutes(router, routes) {
    //const existingRoutes = router.getRoutes();
    //const routeNamesToKeep = ['main', 'dashboard'];
    //const routerStore = useRouterStore();
    const routesToKeep = ['main', 'NotFound', 'untact-normal', 'untact-insurance', 'contract-sign', 'contract-sign-admin']; // , 'login', 'signup', 'signup-normal', 'signup-corp'
    router.getRoutes().forEach((route) => {
        if (!routesToKeep.includes(route.name)) {
            router.removeRoute(route.name);
        }
    });

    for (const route of routes) {
        if (!router.hasRoute(route.name)) {
            const component = await loadComponent(route.componentPath);
            router.addRoute('main', {
                path: route.path,
                name: route.name,
                component: markRaw(component),
                meta: {
                    ...route.meta,
                    keepAlive: true,
                    componentName: component.name
                }
            });
        }
    }

    if (!router.hasRoute('NotFound')) {
        router.addRoute({
            path: '/:pathMatch(.*)*',
            name: 'NotFound',
            component: () => import('@/views/pages/auth/Error.vue'),
            meta: { title: 'Not Found', public: true }
        });
    }

    // const currentRoute = router.currentRoute.value;
    // if (router.hasRoute(currentRoute.name)) {
    //     //routerStore.setCurrentPath(currentRoute.path);
    //     await router.replace({ name: currentRoute.name });
    // } else {
    //     console.warn('현재 경로가 유효하지 않아 dashboard로 이동합니다.');
    //     await router.replace({ name: 'dashboard' });
    // }

    console.log('regist router : ', router.getRoutes().length, ' pages');
    // await router.replace(router.currentRoute.value.fullPath);
    // console.log('regist router : ', router.getRoutes());
}

const router = createRouter({
    history: createWebHistory(),
    routes: [
        // 메인 레이아웃과 대시보드
        {
            path: '/',
            name: 'main',
            component: markRaw(AppLayout),
            // redirect: '/system/reservation',
            children: [
                // 이곳 하단에 넣을경우 top footer 표시됨
                // {
                //     path: '/signup',
                //     name: 'signup',
                //     component: () => import('@/views/pages/signup.vue'),
                //     meta: { title: '회원가입', public: true, keepAlive: true }
                // }
            ]
        },
        // {
        //     path: '/login',
        //     name: 'login',
        //     component: () => import('@/views/pages/login.vue'),
        //     meta: { title: '로그인', public: true }
        // },
        // {
        //     path: '/signup',
        //     name: 'signup',
        //     component: () => import('@/views/pages/signup.vue'),
        //     meta: { title: '회원가입', public: true }
        // },
        // {
        //     path: '/signup-normal',
        //     name: 'signup-normal',
        //     component: () => import('@/views/pages/signup-normal.vue'),
        //     meta: { title: '회원가입(일반)', public: true }
        // },
        // {
        //     path: '/signup-corp',
        //     name: 'signup-corp',
        //     component: () => import('@/views/pages/signup-corp.vue'),
        //     meta: { title: '회원가입(법인)', public: true }
        // },
        {
            path: '/untact-normal',
            name: 'untact-normal',
            component: () => import('@/views/pages/untact-normal.vue'),
            meta: { title: '비대면계약(일반)', public: true }
        },
        {
            path: '/untact-insurance',
            name: 'untact-insurance',
            component: () => import('@/views/pages/untact-insurance.vue'),
            meta: { title: '비대면계약(보험)', public: true }
        },
        {
            path: '/contract-sign',
            name: 'contract-sign',
            component: () => import('@/views/pages/contract-sign.vue'),
            meta: { title: '서명', public: true }
        },
        {
            path: '/contract-sign-admin',
            name: 'contract-sign-admin',
            component: () => import('@/views/pages/contract-sign-admin.vue'),
            meta: { title: '서명', public: true }
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'NotFound',
            component: () => import('@/views/pages/auth/Error.vue'),
            meta: { title: 'Not Found', public: true }
        }
    ]
});

router.afterEach(() => {
    window.scrollTo(0, 0);
});

router.beforeEach(async (to, from, next) => {
    //console.log(`이동 중: ${to.name}, 경로: ${to.path}`);

    const routerStore = useRouterStore();
    const authStore = useAuthStore();
    const signupAccessStore = useSignupAccessStore();

    if (to.name === 'signup-normal') {
        const hasSocialSignupInfo = ['site_type', 'key', 'email'].every((key) => String(to.query[key] || '').trim());
        if (!signupAccessStore.hasAuthorization() && hasSocialSignupInfo) {
            signupAccessStore.authorize('social');
        }

        if (!signupAccessStore.hasAuthorization()) {
            return next({ name: 'signup' });
        }
    }

    // public 페이지 체크
    if (to.meta.public) {
        //console.log('퍼블릭 페이지 접근 허용:', to.path);
        return next();
    }

    // 매칭되는 라우트가 없는 경우 처리
    if (to.matched.length === 0) {
        console.error('해당 라우트가 존재하지 않습니다:', to.fullPath);
        return next({ name: 'NotFound' });
    }

    if (!routerStore.isInitialized && !to.meta.public) {
        try {
            await routerStore.fetchRouterItems();
            await addDynamicRoutes(router, routerStore.routerList);
            routerStore.setInitialized(true);
            return next(to.fullPath);
        } catch (error) {
            console.error('라우트 추가 실패:', error);
            return next('/error');
        }
    }

    //localStorage.setItem('currentPath', to.fullPath);

    if (to.matched.length === 0) {
        console.error('해당 라우트가 존재하지 않습니다:', to.fullPath);
        router.push({ name: 'NotFound' });
    }
    if (to.meta && to.meta.title) {
        routerStore.setCurrentTitle(to.meta.title);
    }
    routerStore.setCurrentPath(to.path);

    if (to.name === from.name && JSON.stringify(to.params) === JSON.stringify(from.params)) {
        return next(false);
    }

    next();
});

export default router;
